<template>
  <div class="settings px">
    <img class="logo" :src="images.logo_white" />
    <div class="version" @click="updateFirmware">
      <span>
        {{ $t("loader.firmwareVersion") }}
        <img
          class="new"
          :src="images.icon_new"
          v-show="!systemInfo.isLatestVersion"
        />
      </span>
      <span class="code">
        {{ systemInfo.version }} <i class="iconfont iconarrow-right" />
      </span>
    </div>
    <div
      class="description"
      v-html="
        !systemInfo.isLatestVersion
          ? $t('loader.updateDescription') +
            (isCN
              ? systemInfo.updateDescription.zh_CN
              : systemInfo.updateDescription.en_US)
          : ''
      "
    ></div>
    <div
      class="button"
      v-if="!systemInfo.isLatestVersion"
      @click="updateFirmware"
    >
      {{ $t("loader.update") }}
    </div>
    <div class="tip" v-if="systemInfo.isLatestVersion">
      {{ $t("loader.isLatestVersion") }}
    </div>
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="progressText"
      @close="onClose"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      percent: -1,
      progressText: "",
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
    }),
  },
  methods: {
    updateFirmware() {
      if (this.systemInfo.isLatestVersion) return;
      this.$store.dispatch("loader/updateLoader");
    },
    onClose() {
      this.percent = -1;
      this.$store.dispatch("loader/restartLoader");
    },
  },
  mounted() {
    window.updatingLoaderProgress = (json) => {
      if (json) {
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent >= 100) {
          console.log("Bridge", "getSystemInfo");
          this.bridge.getSystemInfo();
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    };
  },
};
</script>
<style lang="scss" scoped>
.settings {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 60px;
  }

  .version {
    @include flex-center;
    justify-content: space-between;
    width: 720px;
    padding: 10px 0;
    border-bottom: 3px solid #1d1d1d;
    font-size: 36px;
    margin-bottom: 30px;

    span {
      letter-spacing: 0;
    }

    .code {
      font-size: 28px;
      color: #3c3c3c;
      cursor: pointer;

      .iconfont {
        font-size: 28px;
      }
    }

    .new {
      width: 56px;
      vertical-align: text-top;
      margin-top: -10px;
    }
  }

  .description {
    width: 720px;
    height: 250px;
    word-break: break-all;
    white-space: pre-wrap;
    font-size: 28px;
    overflow-y: auto;
    margin-bottom: 30px;
  }

  .button {
    @include linear-button;
    width: 480px;
    height: 80px;
    line-height: 80px;
    margin-bottom: 60px;
  }

  .tip {
    height: 28px;
    line-height: 28px;
    font-size: 24px;
    text-align: center;
  }
}
</style>
